import { useCountryConfig } from '../../hooks/use-country-config';
import { CountryConfigNames } from '../../contexts/country-config-context/country-config-enums';
import { useEnableAddressValidator } from '../../feature-flags/hooks/use-enable-address-validator';

export const useAddressValidatorConfig = () => {
  const [enableAddressValidatorCountryConfig] = useCountryConfig(CountryConfigNames.AddressValidation);
  const enableAddressValidatorFeatureFlag = useEnableAddressValidator();
  return !!(enableAddressValidatorCountryConfig || enableAddressValidatorFeatureFlag);
};
